<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-title"
      type="select"
      @change="inputChange"
      @input="onInput"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      :rules="required ? 'required' : ''"
      :options="titleOptions"
    />
  </div>
</template>

<script>
import BaseInputMixin from "../../../../mixins/profileInputMixin";
import InputWidget from "../../../core/InputWidget";
import {mapGetters} from "vuex";

export default {
  name: "Title",
  components: {InputWidget},
  mixins: [BaseInputMixin('title')],

  data() {
    return {
      defaultLabel: this.$t("Title",)
    }
  },
  computed: {
    ...mapGetters(["titleOptions"])
  }
}
</script>

<style scoped>

</style>
